import { useEffect, useState } from 'react';
import { ImageInfo } from "../common/ImageInfo";
import './Donate.css';
import { Payment } from './Payment';

const success = `Thank you for your donation to the Wild Horse and Burro Stewardship Program! Your support plays a vital role in ensuring the health and well-being of America's wild horses and burros. Keep an eye on your email for a payment confirmation.

  Have something to share? We'd love to hear about your experience with the Wild Horse and Burro Stewardship Program. If you have feedback or a testimonial you'd like to share, please reach out to us at <a href="mailto:${window.config.SiteContactEmail}">${window.config.SiteContactEmail}</a>.

  Want to learn more? Read testimonials, adoption success stories and more on our <a href="https://www.blm.gov/programs/wild-horse-and-burro/tales-from-the-trails-blog" target="_blank" rel="noreferrer">Tales from the Trails blog</a>.

  Ready to give a good home to a wild horse or burro? Visit our <a href="https://www.blm.gov/programs/wild-horse-and-burro/adoption-and-sales/events" target="_blank" rel="noreferrer">Adoption and Sale Event page</a> to find an event near you, or visit the <a href="https://wildhorsesonline.blm.gov" target="_blank" rel="noreferrer">Online Corral</a> to adopt or purchase a wild horse or burro online.`;

const statusMessages = {
  Canceled: "You have chosen to cancel the pay.gov transaction.",
  Success: success,
  Declined: "The card has been declined. The transaction will not be processed.",
  Error: "There was an error processing the payment. Please try again later.",
};

export function PaymentCallback({ location }) {
  const [paygovMessage, setPaygovMessage] = useState("");
  const [donationStatus, setDonationStatus] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('status');
    if (status === "cancelled") {
      setDonationStatus("Payment Cancelled");
      setPaygovMessage(statusMessages.Canceled);
    } else if (status === "success") {
      setDonationStatus("Donation Confirmation");
      setPaygovMessage(statusMessages.Success);
    } else if (status === "declined") {
      setDonationStatus("Payment Declined");
      setPaygovMessage(statusMessages.Declined);
    } else if (status === "error") {
      setDonationStatus("Payment Error");
      setPaygovMessage(statusMessages.Error);
    } else {
      setDonationStatus("Payment Error");
      setPaygovMessage(`Unknown status code: ${status}`);
    }
  }, [location]);

  const finalPage = () => {
    return (
      <div>
        <Payment paygovMessage={paygovMessage} donationStatus={donationStatus} />
      </div>
    );
  }

  return (
    <div>
      <ImageInfo pageId={4} />
      {finalPage()}
    </div>
  );

}